import React, { Component } from 'react';
import { Card, Row, Col, Button } from '../../../legacy/hui/src/styled/';
import ExtraInstallList from './ExtraInstallList';
import ExtraInstallForm from './ExtraInstallForm';
import info from '../../images/information.svg';
import styled from 'styled-components';
import { Theme } from '../Bunnings/Theme';
import { darken } from 'polished/lib/index';
import PropTypes from 'prop-types';
import getCategoryId from '../../selectors/categoryId';
import Categories from '../../constants/Categories';

const HelpText = Col.extend`
  font-size: 20px;
  color: #555659;
  display: flex;
`;

export const InfoLogo = styled.div`
  width: 25px;
  height: 25px;
  background: url(${info}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  margin-right: 0.5rem;
`;

const ButtonSubmit = Button.extend`
  color: #fff;
  font-size: 14px;
  padding: 8px 20px;
  background-color: ${Theme.primary};
  &:active,
  &:hover,
  &:focus {
    background-color: ${darken(0.1, Theme.primary)};
  }
`;

const InstallCard = Card.extend`
  border: 1px solid #a1a1a3;
  border-radius: 5px;
`;
export default class ExtraInstallCard extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    submitExtraInstallForm: PropTypes.func,
    addExtraInstall: PropTypes.func,
    removeExtraInstall: PropTypes.func,
    categories: PropTypes.array,
    extraInstall: PropTypes.object
  };

  handleClick = () => {
    const { addExtraInstall } = this.props;
    addExtraInstall();
  };

  render() {
    const { submitExtraInstallForm, extraInstall, removeExtraInstall, categories } = this.props;
    const cid = getCategoryId(categories);
    const category = Categories[cid].name;
    const categoryService = Categories[cid].service.toLowerCase();
    return (
      <InstallCard snow p={0} mt={0.8} mb={1}>
        <Row p="1rem 1rem 0 1rem">
          <HelpText xs={12}>
            <InfoLogo /> {category}
          </HelpText>
        </Row>
        <Row p="0.5rem 1rem 0 3rem">
          <Col xs={12}>
            <ExtraInstallList
              extraList={extraInstall.list}
              removeExtraInstall={removeExtraInstall}
            />
          </Col>
        </Row>
        <Row p="1rem 1rem 1.5rem 3rem">
          <Col xs={12}>
            {!extraInstall.loading ? (
              <ButtonSubmit onClick={this.handleClick}>
                {extraInstall.list.length <= 1
                  ? `Add another ${categoryService}`
                  : 'Add another install for the same address'}
              </ButtonSubmit>
            ) : (
              <ExtraInstallForm onSubmit={submitExtraInstallForm} />
            )}
          </Col>
        </Row>
      </InstallCard>
    );
  }
}
